module.exports = __webpack_public_path__ + "img/156.3039eec1.jpg";